import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ConfrimImg from "../../../../assets/Icons/modal/confrim.svg";

const BookCancelSuccess = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const backToBooked = () => {
    onClose();
    navigate("/bookmark");
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full text-center mx-4">
        <img src={ConfrimImg} alt="confrim icon" />
        <h2 className="text-lg font-semibold text-black mb-4">
          {t("Cancel the booking")}...
        </h2>
        <p className="text-sm text-black">
          {t("Your Booking Has Been Canceled")}
        </p>
        <button
          className="mt-4 bg-blue-500 text-white rounded-lg text-sm py-3 px-20"
          style={{ backgroundColor: "#6938ef" }}
          onClick={backToBooked}
        >
          {t("Back to home")}
        </button>
      </div>
    </div>
  );
};

export default BookCancelSuccess;